import React, {useState} from 'react';
import Layout from './../../components/Layout/Layout.js'
import axios from "axios";
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast';
import '../../style/AuthStyle.css'
const Register = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');

    const navigate = useNavigate()
    const handleSubmit = async (e)=>{
      e.preventDefault();
      //console.log(name,email,password,phone,address); return false;
      try {
        const res = await axios.post("/api/v1/auth/register",{name,email,password,phone,address})
        if(res.data.success){
          toast.success(res.data.message,{duration: 4000,position: 'top-center'})
          navigate('/login')
        }else{
          toast.success(res.data.message,{duration: 4000,position: 'top-center'})
        }
      } catch (error) {
        console.log(error)
      }
    }
  return (
    <Layout title={"Register"}>
            <div className='form-container'>
                <form onSubmit={handleSubmit}>
                <h4 className='title'>Register page</h4>
                <div className="mb-3">
                    <input type="text" 
                    className="form-control" 
                    placeholder='Enter your name'
                    value={name}
                    onChange={(e)=>setName(e.target.value)}
                    required
                     />
                </div>
                
                <div className="mb-3">
                    <input type="email" 
                    className="form-control" 
                    placeholder='Enter your email'
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    required
                     />
                </div>
                <div className="mb-3">
                    <input type="password" 
                    className="form-control" 
                    placeholder='Enter your password'
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    required
                     />
                </div>
                <div className="mb-3">
                    <input type="text" 
                    className="form-control" 
                    placeholder='Enter your phone'
                    value={phone}
                    onChange={(e)=>setPhone(e.target.value)}
                    required
                     />
                </div>
                <div className="mb-3">
                    <input type="text" 
                    className="form-control" 
                    placeholder='Enter your address'
                    value={address}
                    onChange={(e)=>setAddress(e.target.value)}
                    required
                     />
                </div>
                <button type="submit" className="btn btn-primary">REGISTER</button>
                </form>

            </div>
    </Layout>
  )
}

export default Register
